export default __webpack_public_path__ + "static/media/renessans.abd8a7f6.svg";